<template>
	<v-card min-width="500px">
		<v-card-text class="pa-0">
			<div class="d-flex flex-row justify-space-between align-center px-4 py-2">
				<div>
					<div class="font-weight-bold caption">Estado de Pago - <span :class="statusColorClass(paymentStatus)">{{paymentStatus.statustext}}</span></div>
					<div class="d-flex flex-row justify-start align-center">
						<div class="d-flex flex-row align-center mr-1">
							<p class="mb-0 caption">
								{{paymentStatus.status == 3 ? 'Monto Aprobado:':'Monto Solicitado Actual:'}}
								<span class="normal font-weight-bold">{{prependToValue}}{{paymentStatus.amount_converted | toThousandFilter(paymentStatus.currency_info?.code === 'UF' ? 2 : 0)}}</span>
							</p>
						</div>
					</div>
					<div class="caption">{{paymentStatus.description}}</div>
				</div>
				<v-btn
					icon
					@click.stop="startCloseMenu()"
				>
					<v-icon color="#5e85ef">mdi-close-circle-outline</v-icon>
				</v-btn>
				<!-- <div class="text-right">
					<div class="text-primary-color caption font-weight-bold" style="line-height: 1;">{{paymentStatus.created_by_user.name}}</div>
					<div class="caption text--disabled">Solicitante</div>
				</div> -->
			</div>
			<v-divider class="mb-1"/>
			<div class="px-4 pb-2 overflow-auto" style="max-height: 400px">
				<div class="my-4" v-if="showNewObservationForm || showModifyPSForm">
					<v-form ref="form" v-model="validform" v-if="showNewObservationForm" transition="slide-y-transition">
						<div class="font-weight-bold mb-2">
							Nueva Observación
							<v-icon color="#2D4B95" class="mr-1" small>mdi-chevron-down</v-icon>
						</div>
						<v-text-field
							v-model="newObservation.description"
							placeholder="Descripción"
							outlined
							dense
							rounded
							hide-details
							:height="20"
							class="mx-1 custom-input-numbers text-center"
							:rules="requiredRule"
						>
						</v-text-field>
						<div class="d-flex align-center justify-space-between mt-2">
							<v-text-field
								v-model.number="newObservation.progress"
								placeholder="Avance"
								type="number"
								outlined
								dense
								rounded
								:height="20"
								class="mx-1 custom-input-numbers text-center"
								:rules="[
									(v) => additional.cost_type !== 1 ? true : (!v || v <= maxProgress || `El avance no puede ser mayor a ${maxProgress.toFixed(2)}%`),
									...requiredRule,
									...percentRule
								]"
								@input="changeProgress"
							>
							</v-text-field>
							<v-text-field
								v-model="newObservation.amount"
								placeholder="Monto"
								type="number"
								outlined
								dense
								rounded
								:height="20"
								class="mx-1 custom-input-numbers text-center"
								:rules="[...requiredRule,...decimalsRule]"
							>
							</v-text-field>
						</div>
						<div class="my-2 d-flex flex-row" style="width: 100%">
							<div class="d-flex justify-space-between" style="width: 100%" :class="$vuetify.breakpoint.mobile ? 'flex-column':'flex-row'">
								<div class="d-flex flex-row align-center justify-start flex-wrap" style="gap: 5px;">
									<div v-for="(file, index) in files_observation" :key="index" class="file-item">
										<v-btn
											icon
											color="#5E85EF"
											x-small
											@click="removeAttachment_observation(index)"
										>
											<v-icon>mdi-close</v-icon>
										</v-btn>
										<v-icon small class="mx-1">{{ file.type.includes('image') ? 'mdi-image' : 'mdi-file-document' }}</v-icon>
										<span class="file-name-truncate">{{ file.name }}</span>
									</div>
								</div>
								<v-btn
									class="mx-2 my-1"
									rounded
									color="white"
									raised
									x-small
									@click="onButtonClick_observation"
								>
									<p class="mb-0 text-primary caption">Adjuntar</p>
								</v-btn>
								<input
									ref="uploader_observation"
									class="d-none"
									type="file"
									@change="onFileChanged_observation"
								>
							</div>
						</div>
						<v-divider class="mb-3 mt-1"></v-divider>
						<div class="d-flex align-center mt-2">
							<v-btn
								class="mx-1"
								rounded
								color="#2D4B95"
								raised
								small
								outlined
								:loading="$store.adicionalesStore.state.listado.status === 99 || loading"
								@click.stop="cancelForms"
							>
								<p class="mb-0">Cancelar</p>
							</v-btn>
							<v-btn
								class="flex-grow-1 mx-1"
								rounded
								color="#2D4B95"
								raised
								small
								:loading="$store.adicionalesStore.state.listado.status === 99 || loading"
								@click.stop="sendNewObservation"
							>
								<p class="mb-0 white--text">Enviar Observación</p>
							</v-btn>
						</div>
					</v-form>

					<v-form ref="formModify" v-model="validformModify" v-if="showModifyPSForm" transition="slide-y-transition">
						<div class="font-weight-bold mb-2">
							Modificar Estado de Pago
							<v-icon color="#2D4B95" class="mr-1" small>mdi-chevron-down</v-icon>
						</div>
						<div class="d-flex align-center justify-space-between mt-2">
							<v-text-field
								v-model="modifyPS.progress"
								placeholder="Avance"
								type="number"
								outlined
								dense
								rounded
								hide-details
								:height="20"
								class="mx-1 custom-input-numbers text-center"
								:rules="[...requiredRule, ...percentRule]"
								@input="changePSProgress"
							>
							</v-text-field>
							<v-text-field
								v-model="modifyPS.amount"
								placeholder="Monto"
								type="number"
								outlined
								dense
								rounded
								hide-details
								:height="20"
								class="mx-1 custom-input-numbers text-center"
								:rules="[...requiredRule,...decimalsRule]"
							>
							</v-text-field>
						</div>
						<v-divider class="my-4"></v-divider>
						<div class="d-flex align-center mt-2">
							<v-btn
								class="mx-1"
								rounded
								color="#2D4B95"
								raised
								small
								outlined
								:loading="$store.adicionalesStore.state.listado.status === 99 || loading"
								@click.stop="cancelForms"
							>
								<p class="mb-0">Cancelar</p>
							</v-btn>
							<v-btn
								class="flex-grow-1 mx-1"
								rounded
								color="#2D4B95"
								raised
								small
								:loading="$store.adicionalesStore.state.listado.status === 99 || loading"
								@click.stop="sendUpdatePS"
							>
								<p class="mb-0 white--text">Modificar Estado de Pago</p>
							</v-btn>
						</div>
					</v-form>
				</div>
				<v-timeline
					v-else
					align-top
					dense
				>
					<v-timeline-item
						v-for="(ps, index) in paymentStatus.interactions"
						:key="index"
						small
					>
						<v-card class="px-2 py-1 caption elevation-2">
							<div class="font-weight-normal">
								<strong>{{ ps.created_by_user.name }}</strong> | <small>{{ ps.updated_at | toDateTime }}</small>
							</div>
							<v-divider class="mb-1"/>
							<div>{{ ps.description }}</div>
							<v-row align="center">
								<v-col cols="6">
									<div class="d-flex flex-row align-center mr-1">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-icon color="#2D4B95" class="mr-1" small
													v-bind="attrs"
													v-on="on">mdi-progress-check</v-icon>
											</template>
											<span>Porcentaje de avance informado</span>
										</v-tooltip>
										<v-progress-linear
											:value="ps.progress*100"
											color="primary"
											height="12"
											rounded
										>
											<small :class="ps.progress < 0.43 ? '':'white--text'">{{ Math.round(ps.progress*100) }}%</small>
										</v-progress-linear>
									</div>
								</v-col>
								<v-col cols="6">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="d-flex flex-row align-center mt-1"
													v-bind="attrs" v-on="on">
												<p class="mb-0 normal font-weight-bold">{{prependToValue}}</p>
												<p class="mb-0 mr-2 normal font-weight-bold">{{ps.amount_converted | toThousandFilter(ps.currency_info?.code === 'UF' ? 2 : 0)}}</p>
												<v-progress-circular
													:size="20"
													:width="6"
													:value="ps.amount*100/additional.last_revision.total_requested"
													color="#3EBFA3"
												/>
											</div>
										</template>
										<span>Monto negociado para el estado de pago</span>
									</v-tooltip>
								</v-col>
							</v-row>
							<div v-if="ps.files?.length" class="file-list-container mt-3">
								<v-divider class="my-1"></v-divider>
								<div class="d-flex flex-row align-center justify-space-between mb-2" style="flex-wrap: wrap; gap: 8px;">
									<div class="d-flex align-center">
										<v-icon x-small class="mr-1" color="#5E85EF">mdi-paperclip</v-icon>
										<span class="font-weight-bold text--secondary caption">Adjuntos ({{ ps.files.length }})</span>
									</div>
									<v-btn
										v-if="ps.files.length > 1"
										color="#5E85EF"
										outlined
										x-small
										height="24"
										:loading="loadingFilePath"
										@click="downloadAttachments(ps.files)"
										class="caption"
									>
										<v-icon x-small>mdi-download</v-icon>
										<span class="ml-1" style="font-size: 0.65rem;">Descargar Todo</span>
									</v-btn>
								</div>
								<div class="d-flex flex-row" style="gap: 8px; flex-wrap: wrap;">
									<AttachmentPreviewButton
										v-for="(file, index) in ps.files"
										:key="`preview-${index}`"
										:attachment="normalizeAttachment(file)"
										:loading="loadingFilePath"
										compact
										@preview="previewAttachment"
									/>
									<v-btn
										v-for="(file, index) in ps.files"
										:key="index"
										:href="file.pathmedia.path"
										target="_blank"
										text
										x-small
										class="file-btn"
										style="background-color: #e3ebff;"
										height="28"
									>
										<v-icon x-small class="mr-1">{{ file.mime_type.includes('image') ? 'mdi-image' : 'mdi-file-document' }}</v-icon>
										<span class="file-name-truncate" style="max-width: 120px; font-size: 0.5rem;">{{ file.name }}</span>
										<v-icon x-small class="ml-1">mdi-open-in-new</v-icon>
									</v-btn>
								</div>
							</div>
						</v-card>
					</v-timeline-item>
				</v-timeline>
					<GlobalFileViewer
						:media-items="viewerMediaItems"
						:media-index="viewerMediaIndex"
						:document-item="viewerDocumentItem"
						:forge-item="viewerForgeItem"
						@close="closeAttachmentViewer"
						@minimize-file="minimizeAttachmentViewer"
						@open-morphable="openItemMorphable"
						@error="onViewerError"
						@load="onViewerLoad"
					/>
			</div>
			<div class="px-4 pb-2" v-if="!showNewObservationForm && !showModifyPSForm">
				<v-divider class="mb-1"/>
				<div class="d-flex align-center justify-space-between">
					<v-btn
						class="mx-2"
						rounded
						color="#2D4B95"
						outlined
						raised
						x-small
						:loading="$store.adicionalesStore.state.listado.status === 99 || loading"
						:disabled="[additionalPaymentStatuses.PAYED].includes(paymentStatus.status)"
						@click.stop="showNewObservationForm = !showNewObservationForm"
					>
						<p class="mb-0">Agregar Observación</p>
					</v-btn>
					<v-btn
						class="mx-2"
						rounded
						color="#2D4B95"
						raised
						small
						:loading="$store.adicionalesStore.state.listado.status === 99 || loading"
						v-if="additional.userprojectjobtype.job_type_id !== 4 && [additionalPaymentStatuses.ITO_OBSERVED].includes(paymentStatus.status)"
						@click.stop="startModifyPsForm"
					>
						<p class="mb-0 white--text">Modificar</p>
					</v-btn>
					<!-- <div v-if="additional.userprojectjobtype.job_type_id == 4">
						<v-btn
							class="mx-2"
							rounded
							color="#3EBFA3"
							raised
							small
							:loading="$store.adicionalesStore.state.listado.status === 99 || loading"
							v-if="paymentStatus.status != 3"
							@click.stop="approvePaymentStatus"
						>
							<p class="mb-0 white--text">Aprobar</p>
						</v-btn>
						<v-chip
							color="#3EBFA3"
							small
							dark
							v-else>
							Estado de Pago Aprobado
						</v-chip>
					</div> -->
				</div>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import {setStatusToPaymentStatus, newPaymentStatusInteraction, updatePaymentStatus} from '@/helpers/api/additionals'
import {additionalPaymentStatuses} from '@/helpers/constants/additional'
import {getZippedFiles} from '@/helpers/api/fileUploads'
import {getParentElement} from '@/helpers/api/general'
import GlobalFileViewer from '@/components/Globals/Helpers/GlobalFileViewer'
import AttachmentPreviewButton from '@/components/Globals/Helpers/AttachmentPreviewButton'
import {normalizeAttachmentForPreview, toMediaViewerItem} from '@/helpers/attachmentPreview'
import EventBus from '@/helpers/event_bus'
import _debounce from 'lodash/debounce'
import { v4 as uuidv4 } from 'uuid'

export default {
	name: 'PaymentStatusInteraction',
	components: { GlobalFileViewer, AttachmentPreviewButton },
	props: {
		closeMenu: {
			type: Function
		},
		additional: {
			type: Object,
			required: true
		},
		paymentStatus: {
			type: Object,
			required: true
		}
	},
	computed: {
		prependToValue(){
			const code = this.paymentStatus?.currency_info?.code || 'CLP'
			const symbol = this.paymentStatus?.currency_info?.symbol ||'$'
			if(code != symbol){
				return `${code} ${symbol}`
			}
			return code
		},
		maxProgress(){
			if(this.additional.total_progress){
				const maxProgress = 1 - this.additional.total_progress
				return Math.round(maxProgress * 100)
			}
			return 0
		}
	},
	mounted(){
		console.log('paymentStatus', this.paymentStatus)
		console.log('additional', this.additional)
		console.log('maxProgress', this.maxProgress)
		this.debouncedGetAdditionalInformativeTable = _debounce(this.getAdditionalInformativeTable, 500)
		this.setListeners()
	},
	beforeDestroy(){
		EventBus.$off('completedFileUpload')
	},
	data: () => ({
		additionalPaymentStatuses,
		loading: false,
		loadingFilePath: false,
		viewerMediaItems: [],
		viewerMediaIndex: null,
		viewerDocumentItem: null,
		viewerForgeItem: null,
    validform: true,
		validformModify: true,
		showNewObservationForm: false,
		showModifyPSForm: false,
		newObservation: {
			description: null,
			progress: null,
			amount: null
		},
		modifyPS: {
			progress: null,
			amount: null
		},
		files_observation: [],
    requiredRule: [
      v => !!v || 'Campo requerido'
    ],
		percentRule: [
			v => v && v.toString().match(/^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?)$/) || 'El porcentaje de avance debe estar entre 0 y 100'
		],
		decimalsRule: [
			v => v && v.toString().match(/^(\d+(\.\d{0,2})?|\.?\d{1,2})$/) || 'El monto puede tener 2 decimales, formato XXXXXX.XX'
		],
	}),
	methods: {
		normalizeAttachment(attachment){
			return normalizeAttachmentForPreview(attachment)
		},
		previewAttachment(attachment){
			const normalized = normalizeAttachmentForPreview(attachment)
			this.closeAttachmentViewer()

			if(normalized?.pathmedia?.path){
				const mediaItem = toMediaViewerItem(normalized)
				if(mediaItem){
					this.viewerMediaItems = [mediaItem]
					this.viewerMediaIndex = 0
					return
				}
			}

			if(normalized?.pathdoc?.path){
				this.viewerDocumentItem = normalized
				return
			}

			if(normalized?.forge_file?.translated){
				this.viewerForgeItem = normalized
				return
			}

			this.$store.globalStore.dispatch('addMessage', {
				message: 'Este archivo no tiene un visor disponible.',
				title: 'Vista previa no disponible',
				created: new Date(),
				type: 'warning',
				icon: 'mdi-eye-off-outline',
				color: '#FB8500'
			})
		},
		closeAttachmentViewer(){
			this.viewerMediaItems = []
			this.viewerMediaIndex = null
			this.viewerDocumentItem = null
			this.viewerForgeItem = null
		},
		minimizeAttachmentViewer(item){
			if(!item) return
			this.$store.globalStore.commit('addFileToFileManagerHandler', item)
			this.closeAttachmentViewer()
		},
		onViewerError(){
			console.error('Attachment viewer failed to load')
		},
		onViewerLoad(){},
		async openItemMorphable(item){
			const typeMap = {
				'App\\Models\\TasksRestrictions': 'task',
				'App\\Models\\TasksRestrictionsInteractions': 'task_interaction',
				'App\\Models\\Rdi': 'rdi',
				'App\\Models\\RdiInteractions': 'rdi_interaction',
				'App\\Models\\Additional': 'additional',
				'App\\Models\\AdditionalRevision': 'additional_revision',
				'App\\Models\\AdditionalObservation': 'additional_observation'
			}
			const parentTypesMap = {
				'App\\Models\\TasksRestrictions': 'task',
				'App\\Models\\TasksRestrictionsInteractions': 'task',
				'App\\Models\\Rdi': 'rdi',
				'App\\Models\\RdiInteractions': 'rdi',
				'App\\Models\\Additional': 'additional',
				'App\\Models\\AdditionalRevision': 'additional',
				'App\\Models\\AdditionalObservation': 'additional'
			}
			if(!item || !typeMap[item.morphable_type] || !item.morphable_id) return

			const parentType = parentTypesMap[item.morphable_type]
			const data = {
				item_id: item.morphable_id,
				item_type: typeMap[item.morphable_type]
			}

			if(parentType === 'task'){
				this.$store.consultasStore.commit('setCurrentTarea', { loading: true })
			}
			else if(parentType === 'rdi'){
				this.$store.rdiStore.commit('setCurrentRDI', { loading: true })
			}
			else if(parentType === 'additional'){
				this.$store.adicionalesStore.commit('setCurrentAdicional', { loading: true })
			}

			this.closeAttachmentViewer()
			const element = await getParentElement(data)
			if(element.code !== 200) return

			if(parentType === 'task'){
				this.$store.consultasStore.commit('setCurrentTarea', element.task)
			}
			else if(parentType === 'rdi'){
				this.$store.rdiStore.commit('setCurrentRDI', element.rdi)
			}
			else if(parentType === 'additional'){
				this.$store.adicionalesStore.commit('setCurrentAdicional', element.additional)
			}
		},
		startModifyPsForm(){
			if(this.paymentStatus?.interactions.length){
				this.modifyPS = {
					progress: this.paymentStatus.interactions[0].progress * 100,
					amount: this.paymentStatus.interactions[0].amount,
				}
			}
			this.showModifyPSForm = !this.showModifyPSForm
		},
		changePSProgress(){
			this.modifyPS.amount = Math.round(
				this.additional.last_revision.total_requested * (this.modifyPS.progress / 100)
			)
		},
		changeProgress(){
			this.newObservation.amount = Math.round(
				this.additional.last_revision.total_requested * (this.newObservation.progress / 100)
			)
		},
		startCloseMenu(){
			this.closeMenu && this.closeMenu()
		},
		statusColorClass(additional){
			if([additionalPaymentStatuses.APPROVED, additionalPaymentStatuses.PAYED].includes(additional.status)){ return 'normal' }
			else if([additionalPaymentStatuses.REQUESTED, additionalPaymentStatuses.ITO_OBSERVED, additionalPaymentStatuses.CONST_OBSERVED].includes(additional.status)){ return 'medium' }
			return 'high'
		},
		cancelForms(){
			this.showNewObservationForm = false
			this.showModifyPSForm = false
			this.newObservation = {
				description: null,
				progress: null,
				amount: null
			}
			this.modifyPS = {
				progress: null,
				amount: null
			}
			this.files_observation = []
		},
		onButtonClick_observation() {
			this.$refs.uploader_observation.click()
		},
		async onFileChanged_observation(e) {
			const newFile = e.target.files[0]
			this.files_observation.push(newFile)
		},
		removeAttachment_observation(index){
			this.files_observation.splice(index, 1)
		},
		generateUUID(){
			return uuidv4()
		},
		async approvePaymentStatus(){
			this.loading = true
			const data = {
				additional_payment_status_id: this.paymentStatus.id,
				status: additionalPaymentStatuses.APPROVED
			}
			await setStatusToPaymentStatus(data)
			this.debouncedGetAdditionalInformativeTable()
			this.loading = false
		},
		async sendNewObservation(){
      if(this.$refs.form.validate()){
				this.loading = true
				const data = {
					additional_payment_status_id: this.paymentStatus.id,
					description: this.newObservation.description,
					progress: this.newObservation.progress/100,
					amount: this.newObservation.amount
				}
				
				const biggerFiles = []
				const smallerFiles = []
				
				this.files_observation.forEach((file) => {
					if(file && file.size < 1000){
						smallerFiles.push(file)
					}
					else if(file){
						biggerFiles.push({
							type: 12,
							payload: null,
							description: this.newObservation.description,
							total: file.size,
							uuid: this.generateUUID(),
							file,
							attach_files: false
						})
					}
				})
				
				// Agregar archivos pequeños a FormData
				let response = null
				if(smallerFiles.length > 0){
					const formData = new FormData()
					Object.keys(data).forEach((key) => {
						if(data[key]){
							formData.append(key, data[key])
						}
					})
					smallerFiles.forEach((file) => {
						formData.append('files[]', file)
					})
					response = await newPaymentStatusInteraction(formData)
				}
				else{
					response = await newPaymentStatusInteraction(data)
				}
				
				// Enviar archivos grandes al upload center
				if(biggerFiles.length > 0 && response){
					biggerFiles.forEach(file => {
						file.payment_status_id = this.paymentStatus.id
						file.item_id = response.payment_status_interaction?.id
						file.payload = {
							payment_status_id: this.paymentStatus.id,
							agps_interaction_id: response.payment_status_interaction?.id,
							project_id: this.$store.projectsStore.state.selectedProject.id
						}
						this.$store.globalStore.commit('setFilesToUploadCenter', file)
					})
				}
				
				this.debouncedGetAdditionalInformativeTable()
				this.cancelForms()
				this.loading = false
			}
		},
		setListeners(){
			EventBus.$on('completedFileUpload', async (payload) => {
				if(this.isValidPayload(payload)){
					this.debouncedGetAdditionalInformativeTable()
				}
			})
		},
		isValidPayload(payload){
			if(!payload) return false
			if(payload.type !== 12) return false
			
			return payload.payment_status_id !== this.paymentStatus.id
		},
		async sendUpdatePS(){
      if(this.$refs.formModify.validate()){
				this.loading = true
				const data = {
					additional_payment_status_id: this.paymentStatus.id,
					progress: this.modifyPS.progress/100,
					amount: this.modifyPS.amount
				}
				await updatePaymentStatus(data)
			this.debouncedGetAdditionalInformativeTable()
				this.cancelForms()
				this.loading = false
			}
		},
    getAdditionalList(){
      let project_id = null
      if(this.$store.projectsStore.state.selectedProject){
        project_id = this.$store.projectsStore.state.selectedProject.id
      }
      else{
        const id = localStorage.getItem('selectedProjectID')
        project_id = parseInt(id)
      }
      if(project_id){
        this.$store.adicionalesStore.dispatch('getAdditionals', {project_id})
      }
    },
		async getAdditionalInformativeTable(){
			let project_id = null
			if(this.$store.projectsStore.state.selectedProject){
				project_id = this.$store.projectsStore.state.selectedProject.id
			}
			else{
				const id = localStorage.getItem('selectedProjectID')
				project_id = parseInt(id)
			}
			if(project_id){
				this.$store.adicionalesStore.dispatch('getAdditionalInformativeTable', {project_id})
			}
		},
		async downloadAttachments(attachments){
			this.loadingFilePath = true
			const toZip = attachments
			const files = await getZippedFiles({files_to_zip: toZip})
			if(files.code == 200){
				window.open(files.fileurl);
			}
			this.loadingFilePath = false
		},
	}
}
</script>

<style scoped>
	.text-primary-color{
		color: #2D4B95;
	}
	.high{
		color: #F4516C;
	}
	.medium{
		color: #fb8c00;
	}
	.normal{
		color: #3EBFA3;
	}
	.file-item {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 0px;
	}
	.file-name-truncate {
		max-width: 100px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: inline-block;
		font-size: 0.75rem;
	}
</style>